import React from 'react';

const SEO = ({ 
  title = "Otter River Properties",
  description = "Quality property management services in Lynchburg, VA. Find your perfect rental home with transparent policies and exceptional service.",
  keywords = "property management Lynchburg VA, rental homes Lynchburg, apartments for rent Lynchburg, houses for rent Lynchburg VA, Lynchburg rentals, property rentals Virginia",
  image = null,
  url = null,
  type = "website",
  structuredData = null
}) => {
  const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';
  const siteUrl = url || (typeof window !== 'undefined' ? window.location.href : BACKEND_URL);
  const defaultImage = `${BACKEND_URL}/logo.png`; // Fallback to logo
  const ogImage = image || defaultImage;
  
  // Construct full title
  const fullTitle = title === "Otter River Properties" ? title : `${title} | Otter River Properties`;

  return (
    <>
      {/* Basic Meta Tags - React 19 Native Support */}
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      
      {/* Open Graph Tags for Facebook, LinkedIn */}
      <meta property="og:type" content={type} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:url" content={siteUrl} />
      <meta property="og:site_name" content="Otter River Properties" />
      
      {/* Twitter Card Tags */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />
      
      {/* Additional SEO Tags */}
      <meta name="robots" content="index, follow" />
      <meta name="author" content="Otter River Properties" />
      <link rel="canonical" href={siteUrl} />
      
      {/* Structured Data (JSON-LD) */}
      {structuredData && (
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      )}
    </>
  );
};

export default SEO;
